import React from "react";
import { Link } from "react-router-dom";
import SectionTitle from "../SectionTitle/SectionTitle";
import blogs from '../../api/blogs';

const ClickHandler = () => {
    window.scrollTo(10, 0);
}

// Helper function to shuffle blogs
const getRandomBlogs = (arr, n) => {
    const shuffled = [...arr].sort(() => 0.5 - Math.random());
    return shuffled.slice(0, n);
}

const BlogSection = (props) => {
    const randomBlogs = getRandomBlogs(blogs, 3);

    return (
        <section className={"" + props.tClass}>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-9 col-12">
                        <SectionTitle title={"Our Articles"} subtitle={"Newsroom"} />
                    </div>
                </div>
                <div className="row">
                    {randomBlogs.map((bloge, bkye) => (
                        <div className="col-lg-4 col-md-6 col-12" key={bkye}>
                            <div className="blog_card">
                                <img src={bloge.blogSingleImg} alt="" />
                                <span>{bloge.tag}</span>
                                <div className="content">
                                    <ul>
                                        <li>{bloge.create_at}</li>
                                        <li>{bloge.author}</li>
                                    </ul>
                                    <h3 className="line-clamp-2">{bloge.title}</h3>
                                    <Link onClick={ClickHandler} to={`/newsroom/${bloge.slug}`}><i className="flaticon-right-arrow"></i></Link>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default BlogSection;
